import { CustomImageField } from "components/RenderInput"
import React, { useEffect, useState } from "react"
import { Card, CardBody, CardHeader, Col, Row } from "reactstrap"
import { change, Field, formValueSelector, isDirty, reset } from "redux-form"
import { FORM_NAMES } from "constants/index"
import { connect } from "react-redux"
import UnsavedAlertModal from "components/UnsavedAlertModal"

const BrandImageTab = ({
  image,
  change,
  isDirty,
  resetForm,
  tabIsActive,
  handleSave,
}) => {
  const [showAlertModal, setShowAlertModal] = useState(false)

  useEffect(() => {
    if (!tabIsActive && isDirty) {
      setShowAlertModal(true)
    }
  }, [tabIsActive])

  return (
    <React.Fragment>
      <Card>
        <CardHeader style={{ minWidth: "300px" }}>
          <h4>Add a default logo or image </h4>
        </CardHeader>
        <CardBody>
          <Row>
            <Col
              xs={12}
              xl={2}
              className="mt-2"
              style={{ minWidth: "fit-content" }}
            >
              <label>Brand Image:</label>
            </Col>
            <Col xs="auto" className="my-1">
              <Field
                name="brandImage"
                type="file"
                component={CustomImageField}
                removeButtonDisabled={true}
                onChange={() => {
                  change("design.deleteBrandImage", 1)
                }}
              />
            </Col>
            <Col
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-end",
              }}
            >
              {image && image?.editedImage && (
                <img
                  src={image?.editedImage ? image?.editedImage : ""}
                  alt="brandImage"
                  className="rounded avatar-xl"
                  style={{ blockSize: "auto" }}
                />
              )}
            </Col>
          </Row>
        </CardBody>
      </Card>
      <UnsavedAlertModal
        isOpen={showAlertModal}
        onClose={() => {
          setShowAlertModal(false)
          resetForm()
        }}
        onSave={() => {
          handleSave()
          setShowAlertModal(false)
        }}
      />
    </React.Fragment>
  )
}

const selector = formValueSelector(FORM_NAMES.PLATFORM_SETTINGS)

const mapStateToProps = state => ({
  image: selector(state, "design.brandImage"),
  isDirty: isDirty(FORM_NAMES.PLATFORM_SETTINGS)(
    state,
    ...["design.brandImage"]
  ),
})

const mapDispatchToProps = dispatch => ({
  change: (field, value) =>
    dispatch(change(FORM_NAMES.PLATFORM_SETTINGS, `${field}`, value)),
  resetForm: () => dispatch(reset(FORM_NAMES.PLATFORM_SETTINGS)),
})

export default connect(mapStateToProps, mapDispatchToProps)(BrandImageTab)
